import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { RestaurantCartProvider, checkoutClient } from '@happyspace/sdk/restaurant';
import { DataProvider } from '@happyspace/sdk/data';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import ProductsPage from './pages/ProductsPage';
import CheckoutPage from './pages/CheckoutPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ReservationsPage from './pages/ReservationsPage';
import OrderStatusPage from './pages/OrderStatusPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';

// checkoutClient SDK is used in CheckoutPage, OrderConfirmationPage, OrderStatusPage
export { checkoutClient };

export default function App() {
  return (
    <DataProvider>
      <RestaurantCartProvider>
        <BrowserRouter>
          <div className="flex flex-col min-h-screen bg-white">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                {/* Core pages */}
                <Route path="/" element={<HomePage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/menu" element={<MenuPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/reservations" element={<ReservationsPage />} />
                <Route path="/order-status/:orderId" element={<OrderStatusPage />} />
                <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
          </div>
        </BrowserRouter>
      </RestaurantCartProvider>
    </DataProvider>
  );
}
